import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch } from 'src/app/store/hooks';
import { ChangeOrganizationModal } from 'src/common/ChangeOrganizationModal';
import { UserProfileRead } from 'src/common/external/bambi-api/bambiApi';
import {
  DRIVER_APP_URL_ANDROID,
  DRIVER_APP_URL_IOS,
} from 'src/common/external/constants';
import { Logo } from 'src/common/Logo';

import { authSlice } from './auth.slice';
import { authService } from './authService';

export function AssociateNotice({
  profile,
}: {
  profile?: UserProfileRead | null;
}) {
  const dispatch = useAppDispatch();

  if (!profile) {
    return null;
  }

  const hasMultipleOrganizations = profile.memberships.length > 1;

  return (
    <div className="flex h-[100vh] w-[100vw] items-center justify-center ">
      <div className="m-16 w-full max-w-lg rounded-lg border border-gray-200 text-center shadow-sm">
        <div className="m-16">
          <div className="mx-auto flex justify-center">
            <Logo />
          </div>
          <h4 className="mt-3 text-lg text-gray-700">Role: Associate</h4>
          <p
            className="text-gray-500"
            data-testid="associate-notice-description"
          >
            Associates are not able to use the web app, please use the driver
            app instead
            {hasMultipleOrganizations ? ' or switch organizations.' : '.'}
          </p>
          <div className="mt-3 flex justify-center gap-2 text-gray-700">
            <Button
              variant="primary"
              onClick={() => {
                window.location.href = DRIVER_APP_URL_IOS;
              }}
            >
              Apple App Store
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                window.location.href = DRIVER_APP_URL_ANDROID;
              }}
            >
              Google Play Store
            </Button>
          </div>
          <div className="mt-4 flex justify-center gap-2">
            {hasMultipleOrganizations && (
              <div>
                <Button
                  dataTestId="change-organization-button"
                  variant="secondary"
                  onClick={() => {
                    dispatch(
                      authSlice.actions.setIsOrganizationChangeOpen(true)
                    );
                  }}
                >
                  Change Organization
                </Button>
              </div>
            )}
          </div>
          <div className="mt-4">
            <Button
              dataTestId="sign-out-button"
              variant="secondary"
              onClick={authService.signOut}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      <ChangeOrganizationModal />
    </div>
  );
}
